// frontend/src/StoreLocator/apiClient.js — /api/store-locator
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/store-locator';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try { const j = await resp.json(); detail = typeof j.detail === 'string' ? j.detail : JSON.stringify(j.detail); } catch { /* the status is enough */ }
    throw new Error(detail || `${resp.status} ${resp.statusText}`);
  }
  return resp.json();
}
const send = (method, path, body) => authenticatedFetch(`${BASE}${path}`, { method, headers: { 'Content-Type': 'application/json' }, body: body === undefined ? undefined : JSON.stringify(body) }).then(jsonOrThrow);
const get = (path) => authenticatedFetch(`${BASE}${path}`).then(jsonOrThrow);
const upload = (path, file) => { const fd = new FormData(); fd.append('file', file); return authenticatedFetch(`${BASE}${path}`, { method: 'POST', body: fd }).then(jsonOrThrow); };

export const slApi = {
  meta: () => get('/meta'),
  locations: () => get('/locations'),
  location: (id) => get(`/locations/${id}`),
  create: (body) => send('POST', '/locations', body),
  update: (id, body) => send('PUT', `/locations/${id}`, body),
  remove: (id) => send('DELETE', `/locations/${id}`),
  geocode: (id) => send('POST', `/locations/${id}/geocode`),
  publishOne: (id) => send('POST', `/locations/${id}/publish`),
  uploadPhoto: (id, file) => upload(`/locations/${id}/photos`, file),
  usePhoto: (id, pid) => send('POST', `/locations/${id}/photos/${pid}/use`),
  removePhoto: (id, pid) => send('DELETE', `/locations/${id}/photos/${pid}`),
  importCsv: (file) => upload('/import', file),
  exportUrl: `${BASE}/export.csv`,
  exportCsv: async () => { const r = await authenticatedFetch(`${BASE}/export.csv`); if (!r.ok) await jsonOrThrow(r); return r.blob(); },
  tags: () => get('/tags'),
  addTag: (body) => send('POST', '/tags', body),
  updateTag: (id, body) => send('PUT', `/tags/${id}`, body),
  removeTag: (id) => send('DELETE', `/tags/${id}`),
  rules: () => get('/special-hours'),
  addRule: (body) => send('POST', '/special-hours', body),
  updateRule: (id, body) => send('PUT', `/special-hours/${id}`, body),
  removeRule: (id) => send('DELETE', `/special-hours/${id}`),
  notices: () => get('/notices'),
  addNotice: (body) => send('POST', '/notices', body),
  updateNotice: (id, body) => send('PUT', `/notices/${id}`, body),
  removeNotice: (id) => send('DELETE', `/notices/${id}`),
  stores: () => get('/stores'),
  themes: (domain) => get(`/stores/${domain}/themes`),
  saveStore: (domain, body) => send('PUT', `/stores/${domain}`, body),
  saveSettings: (body) => send('PUT', '/settings', body),
  uploadMarker: (file) => upload('/settings/marker', file),
  resetMarker: () => send('DELETE', '/settings/marker'),
  publish: (body) => send('POST', '/publish', body || {}),
  publishes: () => get('/publishes'),
  publishStatus: (id) => get(`/publishes/${id}`),
};

export { openBlob } from '../GiftCards/apiClient';
